var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLixo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H9C7.897 2 7 2.897 7 4V6H3V8H5V20C5 21.103 5.897 22 7 22H17C18.103 22 19 21.103 19 20V8H21V6H17V4C17 2.897 16.103 2 15 2ZM9 4H15V6H9V4ZM17 20H7V8H17V20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLixo);
export default __webpack_public_path__ + "static/media/lixo.f92bf1d92f6e780f352aec9d6a265ba3.svg";
export { ForwardRef as ReactComponent };